import { fetch } from '@/shared/fetch';
import { IPet } from '@/shared/interfaces';

export const fetchPets = async () => {
    return await fetch<IPet[]>('/api/pets', 'GET');
};
